if($('header#header').length){
    $('.responsive-tools').append($('.top-navigation-tools .dropdown').clone(), $('.header-top .navigation-buttons a[data-target="cart"]').clone());
    $('.header-top .navigation-buttons').append($('.responsive-tools'));  
}